<div class="modal fade" data-target="success-alert2" id="success-alert2" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" data-keyboard="false"
  data-backdrop="static" aria-labelledby="" aria-hidden="true" style="top: 50px;">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Success</h5>
        <button _ngcontent-c1="" aria-label="Close" class="close" data-dismiss="modal" type="button" (click)="onOkFunction();">
          <span _ngcontent-c1="" aria-hidden="true" >
            <i class="fa fa-times"></i>
          </span>
          <input type="hidden" id="route2" value="" name='routeLink'>
        </button>
      </div>
      <div class="modal-body">
        <i class="fa fa-check-circle success-icon"></i>
        <span id="alertSuccessMessage2">

        </span>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-primary btn-ok" (click)="onOkFunction();" data-dismiss="modal">
          <i class="fa fa-check"></i>&nbsp;OK</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" data-target="note-alert2" id="note-alert2" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" data-keyboard="false"
  data-backdrop="static" aria-labelledby="" aria-hidden="true" style="top: 50px;">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Note</h5>
        <button _ngcontent-c1="" aria-label="Close" class="close btn-ok" data-dismiss="modal" type="button" (click)="onOkFunction();" data-dismiss="modal">
          <span _ngcontent-c1="" aria-hidden="true" >
            <i class="fa fa-times"></i>
          </span>
          <input type="hidden" id="route2" value="" name='routeLink'>
        </button>
      </div>
      <div class="modal-body">
        <span id="noteSuccessMessage2">

        </span>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-primary btn-ok" (click)="onOkFunction();" data-dismiss="modal">
          <i class="fa fa-check"></i>&nbsp;OK</button>
      </div>
    </div>
  </div>
</div>

<div class="modal toast-modal" id="note-alert3" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Upcoming Meeting</h5>
        <button _ngcontent-c1="" aria-label="Close" class="close btn-ok1" data-dismiss="modal" type="button" (click)="onOkFunction();" data-dismiss="modal">
          <span _ngcontent-c1="" aria-hidden="true" >
            <i class="fa fa-times"></i>
          </span>
          <input type="hidden" id="route2" value="" name='routeLink'>
        </button>
      </div>
      <div class="modal-body">
        <span id="noteMeetingMessage">

        </span>
      </div>
      <div class="modal-footer">
        <button type="button" style="margin-top: unset;" class="btn btn-sm btn-primary btn-ok" (click)="onOkFunction();" data-dismiss="modal">
          <i class="fa fa-check"></i>&nbsp;Join Meeting</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="error-alert2" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
          <h5 class="modal-title">Error</h5>
        <button _ngcontent-c1="" aria-label="Close" class="close" data-dismiss="modal" type="button">
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <i class="fa fa-times-circle error-icon"></i>
        <span id="alertErrorMessage2">

        </span>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-primary btn-ok" (click)="onOkFunction();" data-dismiss="modal">
          <i class="fa fa-check"></i>&nbsp;OK</button>
      </div>
    </div>
  </div>
  </div>



  <div class="modal fade" data-target="success-alert" id="success-alert" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" data-keyboard="false"
  data-backdrop="static" aria-labelledby="" aria-hidden="true" style="top: 50px;">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Success</h5>
        <button _ngcontent-c1="" aria-label="Close" class="close" data-dismiss="modal" type="button" (click)="onOkFunction();">
          <span _ngcontent-c1="" aria-hidden="true" >
            <i class="fa fa-times"></i>
          </span>
          <input type="hidden" id="route2" value="" name='routeLink'>
        </button>
      </div>
      <div class="modal-body">
        <i class="fa fa-check-circle success-icon"></i>
        <span id="alertSuccessMessage">

        </span>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-primary btn-ok" (click)="onOkFunction();" data-dismiss="modal">
          <i class="fa fa-check"></i>&nbsp;OK</button>
      </div>
    </div>
  </div>
</div>
